import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import TimedTestSessionPlayer from '../components/test-prep/TimedTestSessionPlayer';

export default function TestSessionPage() {
  const { domain, testId } = useParams();
  const navigate = useNavigate();

  const handleNavigate = (target, data) => {
    if (target === 'score_report' && data?.sessionId) {
      navigate(`/tests/${domain}/report/${data.sessionId}`);
    } else if (target === 'score_report') {
      navigate(`/tests/${domain}`);
    } else if (target === 'test_list') {
      navigate(`/tests/${domain}`);
    }
  };

  return (
    <TimedTestSessionPlayer
      scene={{
        test_id: testId,
        domain_id: domain,
        onNavigate: handleNavigate,
      }}
      rendererConfig={{
        timer_warning_minutes: 35,
        allow_back_within_section: true,
        break_between_sections: 10,
      }}
    />
  );
}
